import { Job } from '../comeet/types';

export const FILTER_PARAMS = { location: 'location', department: 'department' } as const;

export interface FilterValues {
    location: string | null;
    department: string | null;
}

// SEO-friendly slug of a filter value: lowercase, whitespace runs collapsed to single hyphens.
// "Tel Aviv-Yafo" -> "tel-aviv-yafo". Lossy (space and hyphen both become "-"), so reads
// must match by comparing slugs, never by reversing.
export const slugifyFilter = (value: string): string => value.trim().toLowerCase().replace(/\s+/g, '-');

export const filterJobs = (jobs: Job[], f: FilterValues): Job[] =>
    jobs
        .filter((j) => !f.location || j.location === f.location)
        .filter((j) => !f.department || j.department === f.department);

export const validateFilters = (
    raw: { location?: string | null; department?: string | null },
    jobs: Job[]
): FilterValues => {
    // `raw` values arrive from the URL as slugs. Resolve each back to the real job value by
    // matching slug-to-slug (handles hyphen slugs and legacy "+"/space URLs alike).
    const matchSlug = (incoming: string | null | undefined, values: string[]): string | null => {
        if (!incoming) {
            return null;
        }
        const target = slugifyFilter(incoming);
        return values.find((v) => slugifyFilter(v) === target) ?? null;
    };
    return {
        location: matchSlug(
            raw.location,
            jobs.map((j) => j.location)
        ),
        department: matchSlug(
            raw.department,
            jobs.map((j) => j.department)
        ),
    };
};
